import { HistoryDetailsItem } from "@common/types/auditLog";
import { isRecord } from "../../utils/historyDetailsHelpers";
import { HistoryDocumentDetailsBaseRow } from "./historyDocumentDetailsRow";

export type HistoryDocumentDownloadDetailsRow = HistoryDocumentDetailsBaseRow;

interface DownloadedDocument {
    resourceId: string;
    fileName: string | null;
}

const FALLBACK_DOCUMENT_NAME = "Document";

function readFileName(value: unknown): string | null {
    return typeof value === "string" && value.length > 0 ? value : null;
}

function readBulkDocuments(
    metadata: Record<string, unknown>,
): DownloadedDocument[] {
    const { documents } = metadata;
    if (!Array.isArray(documents)) {
        return [];
    }
    return documents.flatMap((document): DownloadedDocument[] => {
        if (!isRecord(document) || typeof document.id !== "number") {
            return [];
        }
        return [
            {
                resourceId: String(document.id),
                fileName: readFileName(document.fileName),
            },
        ];
    });
}

function readDownloadedDocuments(
    log: HistoryDetailsItem,
): DownloadedDocument[] {
    const metadata = isRecord(log.metadata) ? log.metadata : {};
    const bulkDocuments = readBulkDocuments(metadata);
    if (bulkDocuments.length > 0) {
        return bulkDocuments;
    }
    return [
        {
            resourceId: log.resourceId,
            fileName:
                readFileName(metadata.fileName) ??
                readFileName(log.resource?.label),
        },
    ];
}

export function buildDocumentDownloadDetailsRows(
    log: HistoryDetailsItem,
): HistoryDocumentDownloadDetailsRow[] {
    return readDownloadedDocuments(log).map(({ resourceId, fileName }) => ({
        id: `${log.id}-${resourceId}`,
        resourceType: log.resourceType,
        resourceId,
        fileName: fileName ?? FALLBACK_DOCUMENT_NAME,
        financialAccountId: null,
        financialAccountName: null,
        logDate: log.createdAt,
        date: log.createdAt,
        entityId: log.entityId,
    }));
}
